import { z } from 'zod';

/**
 * Formulaire d'invitation d'un utilisateur dans un compte client.
 *
 * Le rôle est validé contre les quatre rôles de tenant, `PlatformAdmin` (100) exclu : l'API le
 * refuse aussi (voir `InviteTenantUserValidator`), mais laisser le front l'accepter
 * transformerait une règle métier en erreur serveur affichée après coup.
 */
export const inviteUserSchema = z.object({
  tenantId: z.string().min(1, 'Sélectionnez le compte client.'),

  email: z
    .string()
    .min(1, "L'adresse email est obligatoire.")
    .email("L'adresse email n'est pas au bon format.")
    .max(320),

  role: z.union([z.literal(0), z.literal(1), z.literal(2), z.literal(3)]),
});

export type InviteUserInput = z.infer<typeof inviteUserSchema>;
